import React, { useState, useEffect, useRef, FC } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import classNames from 'classnames/bind';
import getPlpTopBanner from '../../../actions/plpTopBanner';
import { readCookie } from '../../../components/common/Cookie';
import getPlpTopBannerImages from '../../selectors/plpTopBanner';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { getLocaleData } from '../../../actions/localeBannerApi/localeClientCall';

import styles from './PlpTopBanner.module.pcss';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const cx = classNames.bind(styles);

const mapStateToProps = (state: import('../../types/rootState').RootState) => ({
  plpTopBannerImages: getPlpTopBannerImages(state)
});

const mapDispatchToProps = {
  setUserDataInSession: getLocaleData,
  callPlpBannerApi: getPlpTopBanner
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PlpTopBannerProps = ConnectedProps<typeof connector>;

const PlpTopBanner: FC<PlpTopBannerProps> = props => {
  const { plpTopBannerImages, callPlpBannerApi, setUserDataInSession, isSelectedFilter = false  } = props;
  const { returningUserImageUrl, newUserImageUrl } = plpTopBannerImages;
  const [isOld, setIsOld] = useState(false);
  const handleOldUser = useRef(() => {});
  const readCustomerData = (): Record<string, string> =>
    JSON.parse(sessionStorage.getItem('customerTypeData')) || {};
  handleOldUser.current = (): void => {
    callPlpBannerApi();
    if (signInCheck().length) {
      const data = readCustomerData();
      const isExcisting = data?.customerType === 'Existing';
      if (isExcisting) {
        setIsOld(isExcisting);
      }
    }
  };
  useEffect(() => {
    handleOldUser.current();
  }, []);
  const imageUrl = isOld ? replaceWithJioCDN(returningUserImageUrl) : replaceWithJioCDN(newUserImageUrl);
  return imageUrl ? (
    <div className={cx('plpTopBanner', isSelectedFilter ? "plpTopBanner-selected-filter" : "")}>
      <img src={imageUrl} alt="topBanner" />
    </div>
  ) : null;
};

export default connector(PlpTopBanner);
